// extracted by mini-css-extract-plugin
module.exports = {"section":"nearby-locations_section__8tMOC","container":"nearby-locations_container__0wiIP","title":"nearby-locations_title__RnpYb"};